import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import List from './list.vue'
import Edit from './editor.vue'
import Password from './password.vue'
import Role from './role.vue'
import Layout from '../layout.vue'

const basePath = '/v-admin/user/management'

export default {
  name: 'userManagement',
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: 'PERM_ADMIN_USER',
    titleI18nKey: 'admin.company.userManagement.title.userManagement',
    menu: {
      get label () {
        return i18n.t('admin.company.userManagement.title.userManagement')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.userManagement.title.userManagement'
      }
    },
    {
      path: `${basePath}/add`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: false,
        titleI18nKey: 'admin.company.userManagement.title.userAdd'
      }
    },
    {
      path: `${basePath}/edit/:accountId`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: true,
        titleI18nKey: 'admin.company.userManagement.title.userEdit'
      }
    },
    {
      path: `${basePath}/role/:accountId`,
      component: Role,
      meta: {
        isNewPage: true,
        isEditMode: false,
        titleI18nKey: 'admin.company.userManagement.title.roleManagement'
      }
    },
    {
      path: `${basePath}/password/:accountId`,
      component: Password,
      meta: {
        isNewPage: true,
        isEditMode: false,
        titleI18nKey: 'admin.company.userManagement.title.resetPassword'
      }
    }
  ]
}
